import React, { Component } from 'react';
import { enableAnimations } from 'config/helpers';
import { Banner, CaseStudies } from './subcomponents';
import './Work.scss';

class Work extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { allArticles, contributors } = this.props;

    return (
      <div className={'single-page single-page--hero'}>
        <Banner />
        <CaseStudies allArticles={allArticles} contributors={contributors} />
      </div>
    );
  }
}

export default Work;
